<template>
  <div class="h-full flex items-center text-center flex-col justify-center m-16">
    <WarningIcon color="#6E6F74" :width="64" :height="64" />
    <p class="text-body text-grey-body mt-16">
      The conversation you are looking for could not be found. <br />
      Refresh the page or select a different conversation.
    </p>
    <div :class="mobile ? 'visible' : 'invisible'">
      <Button value="view conversations" variant="text" aria-hidden="!mobile" @click="handleBack" />
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import WarningIcon from '@/graphics/icons/WarningOutlineIcon.vue';

export default {
  name: 'ConversationNotFound',
  components: { Button, WarningIcon },
  props: {
    onBackClick: {
      type: Function,
    },
    mobile: {
      type: Boolean,
    },
  },
  methods: {
    handleBack() {
      this.onBackClick();
    },
  },
};
</script>
